// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenuBalance__block-xNr20","icon":"MainMenuBalance__icon-1EvJV","text":"MainMenuBalance__text-F5H9G","button":"MainMenuBalance__button-1_K3_"};